import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supplierService } from '../../services/supplierService';
import SupplierForm from '../../components/Suppliers/SupplierForm';
import Toast from '../../components/Common/Toast';

const EditSupplier = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadSupplier = async () => {
      try {
        console.log('📡 [EditSupplier] Cargando proveedor ID:', id);
        const response = await supplierService.getSupplier(id);
        
        if (response.success && response.data) {
          console.log('✅ [EditSupplier] Proveedor cargado:', response.data);
          setSupplier({ ...response.data, id: parseInt(id) });
        } else {
          console.warn('⚠️ [EditSupplier] Proveedor no encontrado');
          setToast({
            isOpen: true,
            message: 'Proveedor no encontrado',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/suppliers');
          }, 2000);
        }
      } catch (error) {
        console.error('❌ [EditSupplier] Error al cargar proveedor:', error);
        setToast({
          isOpen: true,
          message: error.response?.data?.message || 'Error al cargar el proveedor',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/suppliers');
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadSupplier();
    }
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Proveedor actualizado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/suppliers');
    }, 1500);
  };

  const handleError = (error) => {
    setToast({
      isOpen: true,
      message: error.response?.data?.message || 'Error al actualizar el proveedor',
      type: 'error'
    });
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center py-12">
            <div className="text-gray-500">Cargando...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!supplier) {
    return null;
  }

  return (
    <div>
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Editar Proveedor</h1>
            <p className="text-gray-600 mt-1">Modifique la información del proveedor</p>
            <div className="mt-2">
              <span className="text-sm font-mono text-teal-600">Código: {supplier.code}</span>
            </div>
          </div>

          {/* Formulario */}
          <SupplierForm
            isPageMode={true}
            supplier={supplier}
            showEntityTypes={false}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        </div>
      </div>

      {/* Toast de notificaciones */}
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default EditSupplier;

